import { httpCreate } from './http';

const http = httpCreate('/srv/free-invite-activity-participate');

export const freeInviteActivityParticipate = {
	// 获取参与列表 http://showdoc.srv.ourwill.cn/web/#/1?page_id=1833
	getPartakeList(id, params) {
		return http.get(`/${id}`, { params });
	},
};
